module.exports = __webpack_public_path__ + "img/noimage.1abcde31.png";